'use client';

import { useLocale, useTranslations } from "next-intl";
import { Button } from "../ui/button";
import VideoBackground from "../custom/video-background";
import { getAppointmentUrl } from "@/lib/utils";

export default function HeroSection() {
  const t = useTranslations('hero_section');
  const locale = useLocale();
  const appointmentUrl = getAppointmentUrl(locale);

  return (
    <>
      <VideoBackground
        mp4Src="/video/hero.mp4"
        webmSrc="/video/hero.webm"
        poster="/hero-video-poster.jpg"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="relative z-10 flex h-full items-center mx-auto px-6 md:px-12 container">
        <div className="text-white max-w-lg">
          <h1 className="text-3xl md:text-5xl text-white font-bold mb-4">TIBETMED</h1>
          <p className="mb-6 text-lg font-medium">{t("subheading")}</p>
          <Button
            className="rounded-full bg-contrast text-white px-6 leading-7 py-3 font-normal uppercase shadow-lg hover:shadow-xl transition hover:bg-accent-blue hover:cursor-pointer"
            onClick={() => window.open(appointmentUrl, "_blank", "noopener,noreferrer")}
          >
            {t("button_appointment")}
          </Button>
        </div>
      </div>
      <div className="absolute inset-0 bg-black/40 z-0" />
    </>
  );
}
